// src/components/auth/GoogleLoginButton/index.tsx
import React from 'react';

import styles from './styles.module.scss';

const GoogleLoginButton = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID!;
  const redirectUri = `${window.location.origin}/login`;

  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=token&scope=openid%20email%20profile&state=google`;

  return (
    <a
      href={authUrl}
      className={styles.googleLoginButton}
    >
      <img src="/images/google.svg" alt="" />
      Войти через Google
    </a>
  );
};

export default GoogleLoginButton;
